// Mirrors the role values returned by tt-frankford-api /auth endpoints.
export enum Roles {
  Admin = "admin",
  CustomerService = "customerservice",
  SalesRep = "rep",
  SalesManager = "salesmanager",
  Basic = "basic",
  RetailerLevel1 = "retailer1",
  Unverified = "unverified",
}

export interface IUser {
  _id?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  role: Roles;
}
